import React from "react";

export default function SQL_Hosting() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Hosting</h1>
      <p>This is the SQL_Hosting component generated from the SQL JSON.</p>
    </div>
  );
}
